(() => {
  'use strict';
  const designNames = { 'club-standard': 'Classic & Clean', 'mascot-motion': 'Mascot Driven', 'city-after-dark': 'City Inspired', 'signed-team': 'Signature Details', 'womens-fit': "Women's Uniforms", reversible: 'Reversible Uniforms' };
  const constructionNames = { 'single-layer': 'Single layer', 'double-layer': 'Double layer' };
  const designReference = () => {
    const params = new URLSearchParams(location.search);
    const selected = params.get('design');
    const reversible = params.get('uniform') === 'reversible';
    const construction = reversible && Object.hasOwn(constructionNames, params.get('construction')) ? constructionNames[params.get('construction')] : '';
    const productHandle = params.get('product');
    const productTitle = (params.get('product_title') || '').replace(/[\u0000-\u001f\u007f]/g, '').slice(0, 180).trim();
    const validProduct = productHandle && /^[a-z0-9][a-z0-9-]{0,150}$/.test(productHandle) && productTitle;
    const inspiration = reversible ? 'Reversible basketball uniforms' : validProduct ? productTitle : Object.hasOwn(designNames, selected) ? designNames[selected] : '';
    if (!inspiration) return null;
    // Query-string destinations are never used; references stay on this shop.
    const referenceURL = reversible ? new URL('/pages/reversible-basketball-uniforms', location.origin).href : validProduct ? new URL(`/products/${productHandle}`, location.origin).href : '';
    return {
      note: `Your inspiration: ${inspiration}${construction ? ` · ${construction}` : ''}. We'll adapt it to your team.`,
      value: `Design inspiration: ${inspiration}${construction ? `\nConstruction preference: ${construction} (to confirm with a sample)` : ''}${referenceURL ? `\nReference: ${referenceURL}` : ''}`
    };
  };
  // Optional upload API contract: POST multipart FormData with repeated "files".
  // Response: { files: [{ name: originalFileName, url: "https://..." }] }.
  // The service must validate file content, enforce limits and control access.
  // No API keys belong in theme settings. Native Shopify contact receives links only.
  const init = (scope = document) => {
    const reference = designReference();
    scope.querySelectorAll('[data-hc-inquiry]').forEach(section => {
      if (section.dataset.hcReady) return;
      section.dataset.hcReady = 'true';
      const form = section.querySelector('form');
      if (!form) return;
      const referenceField = form.querySelector('[data-hc-design-reference]');
      const referenceNote = section.querySelector('[data-hc-design-reference-note]');
      if (referenceField) {
        referenceField.value = reference?.value || '';
        referenceField.disabled = !reference;
      }
      if (referenceNote) {
        referenceNote.textContent = reference?.note || '';
        referenceNote.hidden = !reference;
      }
      const localPreview = section.dataset.preview === 'true' ||
        location.hostname === '127.0.0.1' || location.hostname === 'localhost';
      const country = form.querySelector('[data-hc-country]');
      if (country) {
        const choices = Array.from(document.getElementById(country.getAttribute('list'))?.options || []);
        const countryWrap = form.querySelector('[data-hc-country-wrap]');
        const countryList = form.querySelector('[data-hc-country-list]');
        const countryToggle = form.querySelector('[data-hc-country-toggle]');
        const countryStatus = form.querySelector('[data-hc-country-status]');
        const validateCountry = () => {
          const value = country.value.trim();
          const found = choices.find(option => option.value.toLocaleLowerCase() === value.toLocaleLowerCase());
          country.setCustomValidity(value && choices.length && !found ? 'Please choose a country or region from the list.' : '');
          return found;
        };
        country.addEventListener('input', validateCountry);
        country.addEventListener('change', () => {
          const found = validateCountry();
          if (found) country.value = found.value;
        });
        // Enhance the native datalist into a consistently searchable touch and
        // keyboard combobox. Without JS, the browser still has its native list.
        if (choices.length && countryWrap && countryList && countryToggle && countryStatus) {
          let activeIndex = -1;
          let filtered = [];
          const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
          const close = () => {
            countryList.hidden = true;
            country.setAttribute('aria-expanded', 'false');
            country.removeAttribute('aria-activedescendant');
            activeIndex = -1;
          };
          const choose = value => {
            country.value = value;
            country.setCustomValidity('');
            close();
            country.dispatchEvent(new Event('change', { bubbles: true }));
          };
          const setActive = index => {
            activeIndex = index;
            Array.from(countryList.children).forEach((option, optionIndex) => {
              option.setAttribute('aria-selected', String(optionIndex === index));
            });
            const option = countryList.children[index];
            if (option) {
              country.setAttribute('aria-activedescendant', option.id);
              option.scrollIntoView({ block: 'nearest' });
            } else country.removeAttribute('aria-activedescendant');
          };
          const show = (all = false) => {
            const query = all ? '' : normalize(country.value.trim());
            filtered = choices.filter(option => !query || normalize(option.value).includes(query));
            countryList.replaceChildren();
            filtered.forEach((option, index) => {
              const item = document.createElement('li');
              item.id = `${country.id}-option-${index}`;
              item.setAttribute('role', 'option');
              item.setAttribute('aria-selected', 'false');
              item.textContent = option.value;
              // Retain input focus so selecting an option does not dismiss the
              // keyboard or close the list before click is delivered on mobile.
              item.addEventListener('pointerdown', event => event.preventDefault());
              item.addEventListener('click', () => choose(option.value));
              countryList.append(item);
            });
            if (!filtered.length) {
              const empty = document.createElement('li');
              empty.className = 'hc-country-empty';
              empty.setAttribute('role', 'presentation');
              empty.textContent = 'No matching country or region. Try another search.';
              countryList.append(empty);
            }
            activeIndex = -1;
            country.removeAttribute('aria-activedescendant');
            countryList.hidden = false;
            country.setAttribute('aria-expanded', 'true');
            countryStatus.textContent = `${filtered.length} countries and regions found.`;
          };
          country.removeAttribute('list');
          country.setAttribute('role', 'combobox');
          country.setAttribute('aria-autocomplete', 'list');
          country.setAttribute('aria-controls', countryList.id);
          country.setAttribute('aria-expanded', 'false');
          countryToggle.hidden = false;
          country.addEventListener('focus', () => show(Boolean(validateCountry())));
          country.addEventListener('input', () => show());
          country.addEventListener('keydown', event => {
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
              event.preventDefault();
              if (countryList.hidden) show();
              if (!filtered.length) return;
              const direction = event.key === 'ArrowDown' ? 1 : -1;
              setActive(activeIndex < 0 ? (direction > 0 ? 0 : filtered.length - 1) : (activeIndex + direction + filtered.length) % filtered.length);
            } else if (event.key === 'Enter' && !countryList.hidden && activeIndex >= 0) {
              event.preventDefault();
              choose(filtered[activeIndex].value);
            } else if (event.key === 'Escape' && !countryList.hidden) {
              event.preventDefault();
              close();
            } else if (event.key === 'Tab') close();
          });
          countryToggle.addEventListener('pointerdown', event => event.preventDefault());
          countryToggle.addEventListener('click', () => {
            const wasOpen = !countryList.hidden;
            country.focus();
            if (wasOpen) close(); else show(true);
          });
          countryWrap.addEventListener('focusout', event => {
            if (!countryWrap.contains(event.relatedTarget)) close();
          });
        }
      }

      form.querySelectorAll('[data-hc-colors]').forEach(group => {
        const otherWrap = group.querySelector('[data-hc-other-wrap]');
        const otherInput = group.querySelector('[data-hc-other-color]');
        const update = () => {
          const selected = group.querySelector('input[type="radio"]:checked');
          const isOther = selected?.value === group.dataset.other;
          otherWrap.hidden = !isOther;
          otherInput.disabled = !isOther;
          otherInput.required = isOther;
          otherInput.setCustomValidity(isOther && !otherInput.value.trim() ? 'Please enter your primary team color.' : '');
        };
        group.addEventListener('change', update);
        otherInput.addEventListener('input', () => {
          otherInput.setCustomValidity(otherInput.value.trim() ? '' : 'Please enter your primary team color.');
        });
        update();
      });

      const input = form.querySelector('[data-hc-files]');
      const zone = form.querySelector('[data-hc-dropzone]');
      const list = form.querySelector('[data-hc-file-list]');
      const error = form.querySelector('[data-hc-upload-error]');
      const uploadState = form.querySelector('[data-hc-upload-state]');
      const links = form.querySelector('[data-hc-upload-links]');
      const submit = form.querySelector('[data-hc-submit]');
      if (!input || !zone || !list || !error || !uploadState || !submit || !links) return;
      // Keep the picker disabled in HTML until its submit protection is installed.
      input.disabled = zone.dataset.uploadEnabled !== 'true';

      let files = [];
      let uploading = false;
      let uploadedSignature = '';
      const fileKey = file => [file.name, file.size, file.lastModified].join(':');
      const signature = () => files.map(fileKey).join('|');
      const showError = message => { error.textContent = message; error.hidden = !message; };
      const clearUploaded = () => {
        uploadedSignature = '';
        links.value = '';
        links.disabled = true;
      };
      const syncPicker = () => {
        if (typeof DataTransfer !== 'function') return;
        const transfer = new DataTransfer();
        files.forEach(file => transfer.items.add(file));
        input.files = transfer.files;
      };
      const renderFiles = () => {
        list.replaceChildren();
        files.forEach((file, index) => {
          const item = document.createElement('li');
          const name = document.createElement('span');
          name.textContent = file.name;
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.textContent = 'Remove';
          remove.setAttribute('aria-label', 'Remove ' + file.name);
          remove.disabled = uploading;
          remove.addEventListener('click', () => {
            if (uploading) return;
            files.splice(index, 1);
            clearUploaded();
            showError('');
            syncPicker();
            renderFiles();
          });
          item.append(name, remove);
          list.append(item);
        });
      };
      const validateFiles = candidates => {
        const maxFiles = Number(zone.dataset.maxFiles) || 0;
        const maxBytes = (Number(zone.dataset.maxMb) || 0) * 1024 * 1024;
        const extensions = input.accept.split(',').map(value => value.trim().toLowerCase()).filter(Boolean);
        if (maxFiles > 0 && candidates.length > maxFiles) return 'Please choose no more than ' + maxFiles + ' files.';
        for (const file of candidates) {
          if (!file.size) return 'The file "' + file.name + '" is empty. Please choose another file.';
          if (maxBytes > 0 && file.size > maxBytes) return 'The file "' + file.name + '" exceeds the ' + zone.dataset.maxMb + ' MB limit.';
          if (extensions.length && !extensions.some(extension => extension.startsWith('.') && file.name.toLowerCase().endsWith(extension))) {
            return 'The file "' + file.name + '" is not a supported format. Please choose ' + input.accept + '.';
          }
        }
        return '';
      };
      const addFiles = additions => {
        if (uploading || input.disabled) return;
        const merged = [...files];
        Array.from(additions).forEach(file => {
          if (!merged.some(existing => fileKey(existing) === fileKey(file))) merged.push(file);
        });
        const message = validateFiles(merged);
        if (message) {
          showError(message);
          syncPicker();
          return;
        }
        files = merged;
        clearUploaded();
        showError('');
        syncPicker();
        renderFiles();
      };
      input.addEventListener('change', () => addFiles(input.files));
      ['dragenter', 'dragover'].forEach(name => zone.addEventListener(name, event => {
        if (input.disabled || uploading) return;
        event.preventDefault();
        zone.classList.add('hc-is-dragging');
      }));
      ['dragleave', 'drop'].forEach(name => zone.addEventListener(name, () => zone.classList.remove('hc-is-dragging')));
      zone.addEventListener('drop', event => {
        event.preventDefault();
        if (!input.disabled && !uploading) addFiles(event.dataTransfer?.files || []);
      });

      form.addEventListener('submit', async event => {
        // The shared local preview runtime intercepts submission before this handler.
        // Keep this guard as well so a preview can never upload even if embedded alone.
        if (localPreview) return;
        if (uploading) { event.preventDefault(); return; }
        if (!files.length) { clearUploaded(); return; }
        if (uploadedSignature === signature() && !links.disabled) return;
        event.preventDefault();
        showError('');
        const fileError = validateFiles(files);
        if (fileError) { showError(fileError); return; }
        let endpoint;
        try {
          const configured = section.dataset.uploadEndpoint?.trim();
          if (!configured) throw new Error('missing endpoint');
          endpoint = new URL(configured, location.origin);
          if (endpoint.protocol !== 'https:' || endpoint.username || endpoint.password) throw new Error('invalid endpoint');
        } catch {
          showError('File upload is unavailable. Please remove the files and send your request; you can share them by email when we reply.');
          return;
        }

        uploading = true;
        submit.disabled = true;
        input.disabled = true;
        form.setAttribute('aria-busy', 'true');
        renderFiles();
        uploadState.hidden = false;
        uploadState.textContent = 'Uploading your files… Please keep this page open.';
        const batch = [...files];
        const batchSignature = signature();
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 45000);
        try {
          const data = new FormData();
          batch.forEach(file => data.append('files', file, file.name));
          const response = await fetch(endpoint.href, {
            method: 'POST',
            body: data,
            credentials: 'same-origin',
            redirect: 'error',
            signal: controller.signal,
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) throw new Error('upload failed');
          const payload = await response.json();
          if (!Array.isArray(payload.files) || payload.files.length !== batch.length) throw new Error('incomplete response');
          const remaining = batch.map(file => file.name);
          const confirmed = payload.files.map(file => {
            if (!file || typeof file.name !== 'string' || typeof file.url !== 'string') throw new Error('invalid file');
            const index = remaining.indexOf(file.name);
            if (index < 0) throw new Error('file mismatch');
            remaining.splice(index, 1);
            const url = new URL(file.url);
            if (url.protocol !== 'https:' || url.username || url.password) throw new Error('invalid file URL');
            return file.name.replace(/[\r\n]/g, ' ') + ': ' + url.href;
          });
          if (remaining.length || signature() !== batchSignature) throw new Error('file selection changed');
          links.value = confirmed.join('\n');
          links.disabled = false;
          uploadedSignature = batchSignature;
          uploadState.textContent = 'Files uploaded. Sending your design request…';
          uploading = false;
          submit.disabled = false;
          input.disabled = false;
          form.removeAttribute('aria-busy');
          // requestSubmit retains browser validation, Shopify hCaptcha and the
          // native contact action. Never use form.submit() or display fake success.
          form.requestSubmit(submit);
        } catch {
          clearUploaded();
          uploadState.hidden = true;
          showError('Your request was not sent. We could not upload the files. Please retry, or remove the files and send your request.');
        } finally {
          clearTimeout(timeout);
          uploading = false;
          submit.disabled = false;
          input.disabled = false;
          form.removeAttribute('aria-busy');
          renderFiles();
        }
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
